import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_System back",
  "use": "ico_System back-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"ico_System back\">\n    <path data-name=\"Union 9\" d=\"M0 10.7 12.482 0l.971 1.132L3.16 9.954h23.319v1.49H3.16l10.293 8.822-.971 1.134z\" transform=\"translate(2.854 5.301)\" style=\"fill:#0051a8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol